{
  "action": "Acesso Efetivo",
  "title": "Acesso efetivo",
  "loading": "Resolvendo acesso…",
  "status": {
    "active": "Ativo",
    "deactivated": "Desativado"
  },
  "super": {
    "super-admin": "Super Administrador",
    "super-user": "Super Usuário"
  },
  "roleAtPlace": "{{role}} · {{place}}",
  "superRung": {
    "action": "Nível super",
    "column": "Super",
    "title": "Nível super de {{displayName}}",
    "description": "Um nível super alcança todas as organizações e locais.",
    "choices": {
      "none": "Nenhum",
      "super-user": "Super Usuário",
      "super-admin": "Super Administrador"
    },
    "hints": {
      "none": "O acesso vem somente das atribuições da pessoa.",
      "super-user": "Alcança todas as organizações e locais; a Administração é somente leitura.",
      "super-admin": "Alcança todas as organizações e locais e pode alterar a Administração, incluindo o nível super de outras pessoas."
    },
    "save": "Salvar",
    "cancel": "Cancelar",
    "forbidden": "Somente um Super Administrador pode alterar um nível super, e nunca o próprio.",
    "notFound": "Este usuário não existe mais."
  },
  "userAssignment": {
    "addTitle": "Adicionar um novo usuário",
    "updateTitle": "Atualizar atribuições de {{displayName}}",
    "email": "E-mail (será o nome de usuário de login)",
    "firstName": "Nome",
    "lastName": "Sobrenome",
    "submit": "Enviar",
    "current": "Atribuições atuais",
    "none": "Nenhuma atribuição ainda.",
    "held": "{{place}}: {{capability}}",
    "replaceHint": "Salvar substitui a atribuição apenas no local escolhido. Os outros locais são mantidos.",
    "forbidden": "Você não pode atribuir pessoas neste local.",
    "notFound": "Este usuário não existe mais.",
    "refused": "Não foi possível salvar a atribuição.",
    "remove": "Remover",
    "removeAt": "Remover {{place}}",
    "removeForbidden": "Você não pode remover pessoas neste local.",
    "removeKeep": "Manter",
    "removeRefused": "Não foi possível remover a atribuição."
  },
  "location": {
    "label": "Local",
    "placeholder": "Escolha um local",
    "nothingFound": "Nenhum local correspondente",
    "assignment": "atribuição",
    "anyLocation": "acessível como super"
  },
  "capability": {
    "user": "usuário",
    "admin": "administrador",
    "super": "super"
  },
  "persona": {
    "producer": "produtor",
    "agent": "agente"
  },
  "rung": {
    "any": "qualquer",
    "admin": "administrador",
    "super": "super",
    "super-admin": "super administrador"
  },
  "summary": {
    "defaultRole": "Perfil padrão",
    "noRole": "Nenhum",
    "lens": "Visão",
    "lensAdmin": "Visão de administrador",
    "lensSupplier": "Visão de fornecedor",
    "canToggle": "pode alternar",
    "noToggle": "sem alternância",
    "noSupplierView": "sem visão de fornecedor",
    "present": "Presente aqui",
    "presentValue": "{{nav}} itens de navegação · {{tab}} abas"
  },
  "roles": {
    "title": "Perfis",
    "empty": "Esta pessoa não possui nada neste local.",
    "capability": "Capacidade",
    "persona": "Persona",
    "via": "{{role}} · compartilhado de {{place}}"
  },
  "tree": {
    "title": "Recursos",
    "showNoGrant": "Mostrar recursos sem concessão aqui",
    "empty": "Nenhum recurso para exibir",
    "openInAccess": "Abrir em Acesso"
  },
  "chips": {
    "granted": "{{source}} · {{rung}}",
    "grantedNoRung": "{{source}}",
    "location": "local",
    "global": "global",
    "share": "compartilhamento",
    "pilot": "piloto",
    "implied": "implícito pelas suas abas",
    "otherLens": "outra visão",
    "rung": "requer {{rung}}",
    "config": "configuração ausente",
    "parent": "sem item pai",
    "no-row": "sem registro"
  },
  "scope": {
    "title": "Escopo de linhas",
    "dataset": "Conjunto de dados",
    "column": "Coluna",
    "values": "Valores",
    "unrestricted": "sem restrição",
    "noColumn": "—",
    "empty": "vazio — toda requisição aqui é recusada"
  },
  "recentChanges": {
    "title": "Alterações recentes",
    "empty": "Nenhuma alteração registrada para esta pessoa ainda"
  },
  "errors": {
    "forbidden": "Apenas um Super Administrador ou Super Usuário pode ver o acesso efetivo de outra pessoa.",
    "notFound": "Nenhum usuário com este id.",
    "generic": "Não foi possível resolver o acesso desta pessoa."
  },
  "level": {
    "nav": "navegação",
    "tab": "aba",
    "section": "seção",
    "action": "ação"
  },
  "features": {
    "administration": "Administração",
    "administration-organisations": "Organizações",
    "administration-org-locations": "Locais da Organização",
    "administration-users": "Usuários",
    "administration-roles": "Perfis",
    "administration-permissions": "Permissões",
    "administration-action-log": "Registro de Ações",
    "administration-audit-log": "Auditoria",
    "administration-organisations-edit": "Editar organizações",
    "administration-org-locations-edit": "Editar locais da organização",
    "administration-users-edit": "Editar usuários",
    "administration-roles-edit": "Editar perfis",
    "administration-permissions-edit": "Editar permissões",
    "management": "Gerenciamento",
    "management-users": "Usuários",
    "management-gmp-pics": "PICs",
    "management-audit": "Alterações recentes",
    "management-users-edit": "Editar usuários",
    "management-users-assign-scope": "Atribuir escopo do usuário",
    "management-gmp-pics-edit": "Atribuir PICs",
    "meq-camera": "MEQ Camera",
    "camera-user-analytics": "Análise de Usuários",
    "camera-grader-scorecard": "Placar do Avaliador",
    "camera-mb-gateway-movement": "Movimentação de Gateways MB",
    "camera-beef-analytics": "Análise de Bovinos",
    "camera-aus-meat-omm": "AUS-MEAT OMM",
    "camera-image-comparison": "Comparação de Imagens",
    "camera-wagyu-demo": "Wagyu",
    "camera-dataset-tagging": "Marcação de conjuntos de dados",
    "camera-dataset-tagging-tag": "Marcar imagens",
    "camera-aus-meat-omm-settings-edit": "Editar configurações do AUS-MEAT OMM",
    "data-analysis-overview": "MEQ Data Analytics",
    "dao-beef-overview": "Visão Geral de Bovinos",
    "dao-producers": "Produtores",
    "dao-comparisons": "Comparações",
    "dao-benchmarking": "Benchmarking",
    "dao-plant-comparison": "Comparação de Plantas",
    "dao-live-to-camera": "Painel Live para Camera",
    "dao-merged-animal-data": "Dados de animais combinados",
    "dao-consignments-edit": "Editar nomes de consignações",
    "gmp-lamb-data-analysis": "Análise de Dados GMP Cordeiro",
    "gmp-dashboard": "Painel",
    "gmp-awards": "Prêmios",
    "gmp-comparison": "Comparação",
    "gmp-animal-health": "Saúde Animal",
    "gmp-producer-dashboard": "Painel do Produtor",
    "gmp-all-clients": "Todos os clientes",
    "gmp-lot-names-edit": "Editar descrições de lotes",
    "gmp-awards-config-edit": "Editar configuração de prêmios",
    "gmp-lamb-bookings": "Reservas GMP Cordeiro",
    "gmp-bookings-bookings": "Reservas",
    "gmp-bookings-weekly-overview": "Visão Geral Semanal",
    "gmp-bookings-admin": "Administração",
    "gmp-bookings-producer": "Produtor",
    "gmp-bookings-bookings-edit": "Editar reservas",
    "gmp-bookings-grids-edit": "Editar grades",
    "gmp-bookings-supply-agreements-complete": "Concluir acordos de fornecimento",
    "gmp-upload": "GMP Upload",
    "gmp-upload-submit": "Enviar um arquivo",
    "meq-live": "MEQ Live",
    "meq-live-admin": "MEQ Live Admin",
    "meq-live-genetics": "MEQ Live Genetics",
    "genetics-harmony-insights": "Harmony Insights",
    "meq-probe": "MEQ Probe",
    "probe-lamb-summary": "Resumo das Leituras de Cordeiros",
    "probe-beef-summary": "Resumo das Leituras de Bovinos",
    "probe-shift-scores": "Pontuações de Turno",
    "usda-audit": "Auditoria USDA",
    "usda-audit-review-edit": "Editar revisões de auditoria",
    "usda-audit-feedback": "Retorno da Auditoria USDA",
    "usda-image-calibration": "Calibração de Imagens USDA",
    "record-labelling-admin": "Rotulagem de Registros",
    "record-labelling-projects-edit": "Editar projetos de rotulagem",
    "my-assignments": "Minhas Atribuições",
    "record-labelling-labels-submit": "Enviar rótulos"
  },
  "legend": {
    "show": "O que isso significa?",
    "hide": "Ocultar a explicação",
    "rungPlaceholder": "nível",
    "location": "Uma concessão registrada nesta localização. O nível indica quem ela alcança: any é qualquer pessoa com um papel aqui, admin são os administradores, super são os papéis super.",
    "global": "Uma concessão mantida no código que vale em todas as localizações, a menos que a localização registre a sua própria. As ações, que são escritas, são concedidas assim.",
    "share": "Esta localização compartilha o recurso com outro local, e a pessoa o possui lá, portanto o possui aqui também. O papel compartilhado nunca é aberto no aplicativo.",
    "pilot": "Esta pessoa está nomeada na concessão, portanto tem o recurso qualquer que seja o seu nível.",
    "implied": "O item de navegação não tem concessão própria. Ele aparece porque uma de suas abas está concedida.",
    "rung": "Existe uma concessão, mas ela exige um nível acima do que este papel possui.",
    "config": "Existe uma concessão, mas faltam à localização as configurações de que o recurso precisa, então ele fica oculto até que sejam adicionadas.",
    "parent": "Este papel atende à concessão do próprio recurso, mas o recurso acima dele não está presente, então ele não pode aparecer.",
    "no-row": "Nada concede este recurso nesta localização e nenhuma concessão global o cobre. Ninguém o vê aqui, nem mesmo os papéis super.",
    "otherLens": "Presente, mas é exibido na outra visão, administrador ou fornecedor, e não naquela em que esta pessoa entra."
  },
  "refusal": {
    "feature-missing": "Isto não está habilitado para a sua localização atual.",
    "scope-empty": "Nenhum produtor está atribuído a você aqui.",
    "scope-violation": "Essa solicitação inclui registros fora do que você pode ver.",
    "action-forbidden": "Você não tem permissão para fazer isso aqui.",
    "export-limit": "Esse período é maior do que esta exportação permite.",
    "org-unmapped": "Esta organização não é reconhecida.",
    "place-unnamed": "Nenhuma organização informada."
  },
  "gate": {
    "error": "Não foi possível carregar o que você pode ver nesta localização.",
    "retry": "Tentar novamente"
  },
  "emptyScope": {
    "title": "Ainda não há nada atribuído a você aqui",
    "body": "Nenhum produtor, fornecedor ou PIC está atribuído a você nesta localização, então não há dados para mostrar. Peça ao seu administrador para atribuí-los."
  },
  "grants": {
    "tab": "Acesso",
    "views": {
      "feature": "Por funcionalidade",
      "location": "Por local"
    },
    "features": {
      "intro": "Escolha uma funcionalidade para ver a concessão em cada local. A linha própria de um local substitui o padrão global.",
      "pick": "Funcionalidade",
      "placeholder": "Escolha uma funcionalidade",
      "nothingFound": "Nenhuma funcionalidade corresponde",
      "global": "Padrão global:",
      "noGlobal": "nenhum, só locais com uma linha a concedem",
      "rowsOnly": "Somente locais com linha própria",
      "noRows": "Nenhum local tem linha própria para esta funcionalidade.",
      "openLocation": "Abrir este local em Por local"
    },
    "locations": {
      "intro": "Escolha um local para ver a concessão de cada funcionalidade nele. Linhas do padrão global valem até o local gravar a sua.",
      "pick": "Local",
      "placeholder": "Escolha um local",
      "nothingFound": "Nenhum local corresponde",
      "rowsOnly": "Somente funcionalidades com linha aqui",
      "noRows": "Este local não tem linhas próprias."
    },
    "columns": {
      "location": "Local",
      "feature": "Funcionalidade",
      "source": "Origem",
      "rungAndPilots": "Nível e pilotos",
      "rungAndPilotsHelp": {
        "title": "O que significam o nível e os pilotos",
        "none": "Ninguém vê a funcionalidade neste local, incluindo os perfis super.",
        "default": "Não há linha aqui, então vale a concessão global definida no código.",
        "super-admin": "Somente super administradores, não super usuários, além dos pilotos da linha.",
        "super": "Somente os perfis super da MEQ.",
        "admin": "Administradores deste local, além dos perfis super.",
        "any": "Todas as pessoas com um perfil neste local.",
        "pilots": "Pessoas nomeadas que recebem a funcionalidade mesmo que o nível não as alcance, para testá-la antes de ampliar. Quem o nível já cobre é removido da lista automaticamente."
      }
    },
    "source": {
      "default": "Padrão global",
      "override": "Substituição",
      "location": "Linha do local"
    },
    "rung": {
      "none": "Nenhum",
      "default": "Padrão",
      "defaultOf": "Padrão · {{rung}}",
      "super-admin": "Super admin",
      "super": "Super",
      "admin": "Admin",
      "any": "Todos"
    },
    "pinned": "Somente super-admin, definido no código",
    "pilots": {
      "label": "Pilotos",
      "placeholder": "Sem pilotos",
      "nothingFound": "Ninguém tem atribuição aqui"
    },
    "stripped": {
      "title": "Pilotos removidos",
      "body_one": "{{names}} já alcança a funcionalidade pelo nível, então não foi mantido como piloto.",
      "body_other": "{{names}} já alcançam a funcionalidade pelo nível, então não foram mantidos como pilotos."
    },
    "configSuppressed": {
      "withPath": "Concedida, sem configuração: defina {{path}}",
      "noPath": "Concedida, sem configuração"
    },
    "shares": {
      "title": "Compartilhamentos",
      "intro": "Um compartilhamento empresta este recurso em uma localização a quem o possui em outra, junto com o que está abaixo dele lá. Essas pessoas o possuem por meio de um papel separado que nunca é aberto no aplicativo, portanto nada novo aparece na navegação delas.",
      "none": "Nenhuma localização compartilha este recurso.",
      "row": "{{owner}} compartilhado com {{audience}}",
      "owner": "Localização",
      "audience": "Compartilhado com",
      "add": "Adicionar compartilhamento",
      "remove": "Remover compartilhamento",
      "badge": "Compartilhado com {{places}}"
    },
    "loading": "Carregando concessões…"
  }
}
